import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "card card-custom card-stretch mb-5 mb-xxl-8" }
const _hoisted_2 = { class: "card-header border-0 pt-5" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h3", { class: "card-title align-items-start flex-column" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "card-label fw-bolder text-dark fs-3" }, "Campaign Leaders"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-muted mt-2 fw-bold fs-6" }, "890,344 Sales")
], -1)
const _hoisted_4 = { class: "card-toolbar" }
const _hoisted_5 = { class: "nav nav-pills nav-pills-sm nav-light" }
const _hoisted_6 = { class: "card-body pt-2 pb-0 mt-n3" }
const _hoisted_7 = {
  class: "tab-content mt-5",
  id: "myTabTables1"
}
const _hoisted_8 = {
  class: "tab-pane fade show active",
  id: "kt_tab_pane_1_1",
  role: "tabpanel",
  "aria-labelledby": "kt_tab_pane_1_1"
}
const _hoisted_9 = { class: "table-responsive" }
const _hoisted_10 = { class: "table table-borderless align-middle" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { class: "p-0 w-50px" }),
    /*#__PURE__*/_createElementVNode("th", { class: "p-0 min-w-200px" }),
    /*#__PURE__*/_createElementVNode("th", { class: "p-0 min-w-100px" }),
    /*#__PURE__*/_createElementVNode("th", { class: "p-0 min-w-40px" })
  ])
], -1)
const _hoisted_12 = { class: "px-0 py-3" }
const _hoisted_13 = { class: "symbol symbol-65px me-5" }
const _hoisted_14 = { class: "ps-0" }
const _hoisted_15 = {
  href: "#",
  class: "text-gray-800 fw-bolder text-hover-primary fs-6"
}
const _hoisted_16 = { class: "text-muted fw-bold d-block mt-1 fs-6" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("td", { class: "ps-0" }, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "#",
    class: "text-gray-800 fw-bolder text-hover-primary fs-6"
  }, " My custom title "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-muted fw-bold d-block mt-1 fs-6" }, " My custom desc ")
], -1)
const _hoisted_18 = { class: "d-flex flex-column w-100 mr-3" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center justify-content-between mb-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-dark mr-2 fs-6 fw-bolder" }, " Progress ")
], -1)
const _hoisted_20 = { class: "d-flex align-items-center" }
const _hoisted_21 = { class: "text-muted fs-7 fw-bold ps-3" }
const _hoisted_22 = { class: "text-end pe-0" }
const _hoisted_23 = {
  href: "#",
  class: "btn btn-icon btn-bg-light btn-active-color-primary btn-sm"
}
const _hoisted_24 = { class: "svg-icon svg-icon-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("ul", _hoisted_5, [
          _createElementVNode("li", {
            class: "nav-item",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.setCurrentData(_ctx.day)))
          }, [
            _createElementVNode("a", {
              class: _normalizeClass(["nav-link btn btn-active-light btn-color-muted py-2 px-4 fw-bolder me-2", { active: _ctx.show === _ctx.day }])
            }, "Day", 2)
          ]),
          _createElementVNode("li", {
            class: "nav-item",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setCurrentData(_ctx.week)))
          }, [
            _createElementVNode("a", {
              class: _normalizeClass(["nav-link btn btn-active-light btn-color-muted py-2 px-4 fw-bolder me-2", { active: _ctx.show === _ctx.week }])
            }, "Week", 2)
          ]),
          _createElementVNode("li", {
            class: "nav-item",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.setCurrentData(_ctx.month)))
          }, [
            _createElementVNode("a", {
              class: _normalizeClass(["nav-link btn btn-active-light btn-color-muted py-2 px-4 fw-bolder", { active: _ctx.show === _ctx.month }])
            }, "Month", 2)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("table", _hoisted_10, [
              _hoisted_11,
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dataToShow, (item, i) => {
                  return (_openBlock(), _createElementBlock("tr", { key: i }, [
                    _createElementVNode("th", _hoisted_12, [
                      _createElementVNode("div", _hoisted_13, [
                        _createElementVNode("span", {
                          class: _normalizeClass(["symbol-label", `bg-light-${item.status}`])
                        }, [
                          _createElementVNode("span", {
                            class: _normalizeClass(["svg-icon svg-icon-1", `svg-icon-${item.status}`])
                          }, [
                            _createVNode(_component_inline_svg, {
                              src: item.icon
                            }, null, 8, ["src"])
                          ], 2)
                        ], 2)
                      ])
                    ]),
                    _createElementVNode("td", _hoisted_14, [
                      _createElementVNode("a", _hoisted_15, _toDisplayString(item.title), 1),
                      _createElementVNode("span", _hoisted_16, _toDisplayString(item.desc), 1)
                    ]),
                    _hoisted_17,
                    _createElementVNode("td", null, [
                      _createElementVNode("div", _hoisted_18, [
                        _hoisted_19,
                        _createElementVNode("div", _hoisted_20, [
                          _createElementVNode("div", {
                            class: _normalizeClass(["progress h-6px w-100", `bg-light-${item.status}`])
                          }, [
                            _createElementVNode("div", {
                              class: _normalizeClass(["progress-bar", `bg-${item.status}`]),
                              role: "progressbar",
                              style: _normalizeStyle({ width: item.progress }),
                              "aria-valuenow": "50",
                              "aria-valuemin": "0",
                              "aria-valuemax": "100"
                            }, null, 6)
                          ], 2),
                          _createElementVNode("span", _hoisted_21, _toDisplayString(item.progress), 1)
                        ])
                      ])
                    ]),
                    _createElementVNode("td", _hoisted_22, [
                      _createElementVNode("a", _hoisted_23, [
                        _createElementVNode("span", _hoisted_24, [
                          _createVNode(_component_inline_svg, { src: "media/icons/duotone/Navigation/Arrow-right.svg" })
                        ])
                      ])
                    ])
                  ]))
                }), 128))
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}